import { render, staticRenderFns } from "./Wxts.vue?vue&type=template&id=7f6057d3&scoped=true&"
import script from "./Wxts.vue?vue&type=script&lang=js&"
export * from "./Wxts.vue?vue&type=script&lang=js&"
import style0 from "./Wxts.vue?vue&type=style&index=0&id=7f6057d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6057d3",
  null
  
)

export default component.exports